export default "__VITE_ASSET__D6u2GkVz__"